var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 15.854L11.25 7.937l-4.167 4.167-6.25-6.25m18.334 10h-5m5 0v-5",
    stroke: "#E73030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIwIDIxIiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTE5LjE2NjYgMTUuODUzNUwxMS4yNDk5IDcuOTM2ODVMNy4wODMyNSAxMi4xMDM1TDAuODMzMjUyIDUuODUzNTJNMTkuMTY2NiAxNS44NTM1SDE0LjE2NjZNMTkuMTY2NiAxNS44NTM1VjEwLjg1MzUiIHN0cm9rZT0iI0U3MzAzMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";
export { SvgTrendingDown as ReactComponent };